import React, { FC } from 'react'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { Navigation } from '../Navigation'

import { ReactComponent as ArrowImg } from '../../images/footer/arrow-up.svg'
import { Version } from '../Version'

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    position: 'relative',
    zIndex: 1000,
    display: 'flex',
    width: '100%',
    height: 248,
    background: theme.palette.primary.dark,
  },

  container: {
    maxWidth: 1184,
    margin: '0 auto',
  },

  nav: {
    padding: '50px 0 17px 0',
  },

  desc: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    color: theme.palette.primary.light,
    opacity: '0.64',
  },

  footerRight: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  dev: {
    paddingRight: 32,

    fontSize: 12,
    textAlign: 'right',
  },

  devLink: {
    textDecoration: 'none',
    color: theme.palette.secondary.light,
  },

  footerArrow: {
    cursor: 'pointer',
  },
}))

export const Footer: FC = () => {
  const classes = useStyles()
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  return (
    <footer className={classes.footer}>
      <Grid item lg className={classes.container}>
        <Grid item className={classes.nav}>
          <Navigation />
        </Grid>

        <Grid container className={classes.desc}>
          <Grid item>
            <Typography variant="body1">
              © Copyright {new Date().getFullYear()} | Sparling Financial | All Rights Reserved
            </Typography>
          </Grid>

          <Grid item className={classes.footerRight}>
            <Typography variant="body1" className={classes.dev}>
              Design and development{' '}
              <a href="https://rightandabove.com/" target={'_blank'} rel="noreferrer" className={classes.devLink}>
                Right&Above
              </a>
            </Typography>
            <ArrowImg onClick={handleClick} className={classes.footerArrow} />
          </Grid>
        </Grid>
      </Grid>
      <Version />
    </footer>
  )
}
